module.exports = __webpack_public_path__ + "media/images/shared/candace-pert-8cb6dc4a2cb674010b58ef6942f386742fbf79d9c09ec755369ab1aded53e552.png";